// developers.google.com/search/docs/appearance/structured-data/employer-rating#structured-data-type-definitions
export const EMPLOYER_AGGREGATE_RATING_BEST = 5;
export const EMPLOYER_AGGREGATE_RATING_WORST = 1;
